<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Tabs :value="currentRoute" @on-click="changeRouter" :loading="$store.state.Convert.syncing">
        <TabPane name="toutiaoproject" label="项目"></TabPane>
        <TabPane name="toutiaoad" label="计划"></TabPane>
      </Tabs>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
<script>
import { synProjectInfo } from '@/api/common.model'

export default {
  name: 'ToutiaoDefault',
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      if (this.$route.name === 'toutiaonew') this.changeRouter('toutiaoproject')
      this.currentRoute = this.$route.name
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: ''
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
